// BalloonCard.js
import React from "react";
import { Card, Button } from "antd";
import "./showcasePopBallon.less";
import { VertButton } from "@vertem-core/vertice-ds";


const BalloonCard = ({ balloon, onSelect }) => {
  return (
    <div className="container-pop-ballon">
      <Card
        className="card-pop-ballon"
        cover={
          <img
            alt="Aniversário Acessa Agro"
            src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/thumb.jpg"
            style={{ borderRadius: "10px 10px 0 0", width: "100%" }}
          />
        }
      >
        <div className="btn-card-pop-ballon">
          <VertButton
            type="highlight"
            onClick={() => onSelect(balloon)}
            className="btn-pop-ballon"
          >
            Estourar Balão
          </VertButton>
        </div>
      </Card>
    </div>
  );
};

export default BalloonCard;
